import { render, staticRenderFns } from "./BackIcon.vue?vue&type=template&id=4fb3d005&scoped=true&"
import script from "./BackIcon.vue?vue&type=script&lang=js&"
export * from "./BackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3d005",
  null
  
)

export default component.exports